<template>
  <i class="ui-loading-mini"></i>
</template>

<script>
export default {
  name: "uiLoadingMini"
}
</script>

<style lang="scss" scoped>
.ui-loading-mini {
  height: 0.24rem;
  width: 0.24rem;
  display: inline-block;
  background: url("./images/icon_loading.png") no-repeat center;
  background-size: 100%;
  animation: loadingRotate 2s linear infinite;

  @keyframes loadingRotate {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
